import React, {Component} from 'react';
import {
    Modal,
    ModalBody,
    ModalHeader,
    Button,
    Row,
    Col,
    Label,
    FormGroup,
    Card,
    CardBody,
    CardHeader,
    CardFooter
  } from 'reactstrap';
 
import urlBase from './../api/UrlBase';
import {  FaCloudDownloadAlt} from 'react-icons/fa';
 
 
import SelectCiclos from './SelectCiclos';
 
class ModalPostulacion extends Component {
 
    constructor(){
        super();
        this.state = {
            estado:'',
        }
 
    }
 
    tipoLiceo = (tipo) => {
        let tipoLiceo = ''
        switch (tipo) {
            case 'cientifico':
                tipoLiceo = 'Cientifico humanista'; 
                break;
            case 'industrial':
                  tipoLiceo = 'Técnico-Industrial'; 
                break;
            case 'comercial':
                  tipoLiceo = 'Comercial'; 
                break;
            case 'comercial':
                    tipoLiceo = 'Polivalente'; 
                  break;
            default: 
                tipoLiceo = 'No definido'; 
                break;
        }
        return tipoLiceo; 
    }
 
 
 
    render(){
 
        const { isOpen, toggle, postulacion, estado, manejaEstado, mostrarGuardar, manejaCiclo, ciclo, confirmar} = this.props;
 
        const { nombres, apellidos, rut, telefono, email, direccion, comuna, nombres2, apellidos2, telefono2, email2, liceo, tipo_liceo, especialidad, mapuche, curso, notas1, notas2, notas3, nem, carrera1, carrera2, carrera3, carrera4, razon_carreras, caracteristica_carreras, conocer_carreras, tipo_conocimiento, documento} = postulacion; 
 
        return (
 
            <Modal  isOpen={isOpen} toggle={toggle}   backdrop="static" className="modal-grande">
                <ModalHeader  toggle={toggle} >
                    Formulario ficha de postulación escuela de talentos pedagógicos
                </ModalHeader>
                <ModalBody>      
 
                    <Row className="no-margin-bottom one-row">
                        <Col  lg={3} md={3} sm={12}>
                            <FormGroup>
                                <Label>Nombres</Label>
                                <span className="form-dato">{nombres}</span>
                            </FormGroup>
                        </Col>
                        <Col  lg={3} md={3} sm={12}>
                            <FormGroup>
                                <Label>Apellidos</Label>
                                <span className="form-dato">{apellidos}</span>
                            </FormGroup>
                        </Col>
                        <Col  lg={2} md={2} sm={12}>
                            <FormGroup>
                                <Label>RUT</Label>
                                <span className="form-dato">{rut}</span>
                            </FormGroup>
                        </Col>
                        <Col  lg={2} md={2} sm={12}>
                            <FormGroup>
                                <Label>Teléfono</Label>
                                <span className="form-dato">{telefono}</span>
                            </FormGroup>
                        </Col>
                        <Col  lg={3} md={3} sm={12}>
                            <FormGroup>
                                <Label>Email</Label>
                                <span className="form-dato">{email}</span>
                            </FormGroup>
                        </Col>
 
                        <Col  lg={4} md={4} sm={12}>
                            <FormGroup>
                                <Label>Dirección</Label>
                                <span className="form-dato">{direccion}</span>
                            </FormGroup>
                        </Col>
                        <Col  lg={2} md={2} sm={12}>
                            <FormGroup>
                                <Label>Comuna</Label>
                                <span className="form-dato">{comuna}</span>
                            </FormGroup>
                        </Col>
 
                    </Row>
 
                    <Row className=" one-row">
                    <Col  lg={3} md={3} sm={12}>
                            <FormGroup>
                                <Label>Nombres Tutor</Label>
                                <span className="form-dato">{nombres2}</span>
                            </FormGroup>
                        </Col>
                        <Col  lg={3} md={3} sm={12}>
                            <FormGroup>
                                <Label>Apellidos Tutor</Label>
                                <span className="form-dato">{apellidos2}</span>
                            </FormGroup>
                        </Col>
                        <Col  lg={2} md={2} sm={12}>
                            <FormGroup>
                                <Label>Teléfono Tutor</Label>
                                <span className="form-dato">{telefono2}</span>
                            </FormGroup>
                        </Col>
                        <Col  lg={3} md={3} sm={12}>
                            <FormGroup>
                                <Label>Email Tutor</Label>
                                <span className="form-dato">{email2}</span>
                            </FormGroup>
                        </Col>
                    </Row>
 
                    <Row className=" one-row">
                        <Col  lg={4} md={4} sm={12}>
                            <FormGroup>
                                <Label>Nombre del liceo</Label>
                                <span className="form-dato">{liceo}</span>
                            </FormGroup>
                        </Col>
                        <Col  lg={3} md={3} sm={12}>
                            <FormGroup>
                                <Label>Tipo de liceo</Label>
                                <span className="form-dato">{this.tipoLiceo(tipo_liceo)}</span>
                            </FormGroup>
                        </Col>
                        <Col  lg={3} md={3} sm={12}>
                            <FormGroup>
                                <Label>Especialidad (si corresponde)</Label>
                                <span className="form-dato">{especialidad}</span>
                            </FormGroup>
                        </Col>
 
                    </Row>
 
 
                    <Row className="one-row">
                        <Col  lg={2} md={2} sm={12}>
                            <FormGroup>
                                <Label>Es mapuche</Label>
                                <span className="form-dato">{mapuche==='1'? 'SI': 'No'}</span>
                            </FormGroup>
 
                        </Col>
                        <Col  lg={2} md={2} sm={12}>
                            <FormGroup>
                                <Label>Curso</Label>
                                <span className="form-dato">{curso}</span>
                            </FormGroup>
                        </Col>
 
                        <Col lg={2} md={2} sm={12}>
                            <FormGroup>
                                <Label>Notas 1°</Label>
                                <span className="form-dato">{notas1}</span>
                            </FormGroup>
                        </Col>
                        <Col lg={2} md={2} sm={12}>
                            <FormGroup>
                                <Label>Notas 2°</Label>
                                <span className="form-dato">{notas2}</span>
                            </FormGroup>
                        </Col>
                        <Col lg={2} md={2} sm={12}>
                            <FormGroup>
                                <Label>Notas 3°</Label>
                                <span className="form-dato">{notas3}</span>
                            </FormGroup>
                        </Col> 
 
 
                        <Col lg={2} md={2} sm={12}>
                            <FormGroup>
                                <Label>NEM</Label>
                                <span className="form-dato">{nem}</span>
                            </FormGroup>
                        </Col>
 
                    </Row>
 
                    <Row>
                        <Col>
                            <Label>Escriba en orden de preferencia el nombre de las carreras que le gustaría estudiar.</Label>
 
                            <FormGroup>
                                <span className="form-dato">{carrera1}</span>
                            </FormGroup>
                            <FormGroup>
                                <span className="form-dato">{carrera2}</span>
                            </FormGroup>
                            <FormGroup>
                                <span className="form-dato">{carrera3}</span>
                            </FormGroup>
                            <FormGroup>
                                <span className="form-dato">{carrera4}</span>
                            </FormGroup>
 
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label >Explique ¿Por qué le gustaría estudiar las 2 primeras carreras señaladas?</Label>
                                <span className="form-dato">{razon_carreras}</span>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label >En UNA sola palabra, ¿cuál crees que es la característica principal de las y los jóvenes que deciden estudiar pedagogía?</Label>
                                <span className="form-dato">{caracteristica_carreras}</span>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label >¿Qué tema en relación a la pedagogía te gustaría conocer?</Label>
                                <span className="form-dato">{conocer_carreras}</span>
                            </FormGroup>
                        </Col>
 
                        <Col  lg={3} md={3} sm={12}>
                            <FormGroup>
                                <Label>¿Cómo te enteraste de la Escuela de Talentos Pedagógicos]?</Label>
                                <span className="form-dato">{tipo_conocimiento}</span>
                            </FormGroup>
                        </Col>
                    </Row>
                    {
                        documento!=="" ?(
                            <Row>
                                <Col>
                                    <Label>Archivo zip con los documentos adjuntados por el postulante</Label>
 
                                    <div>
                                        <a href={urlBase+documento} target="_self" className="btn btn-primary btn-sm" download><FaCloudDownloadAlt/> Descargar archivo</a>
                                    </div>
                                </Col>
                            </Row>
                        ) : 
                        <Row>
                            <Col>
                                <Label style={{color: "#ca4e4e"}}>Postulante no adjunto ningun documento</Label>
                            </Col>
                        </Row>
 
                    }
                    <br/><br/>
                    <Card>
                        <CardHeader>
                            Evaluación de postulación
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col sm={12}>
                                    {
                                        estado==='Aceptada' && 
                                        <div className="mensaje-modal-postulacion">
                                            Debe seleccionar un ciclo para registrar al postulante como estudiante
                                        </div>
                                    }
                                    <br/>
                                </Col>
 
                                <Col lg={3} md={6} sm={12} style={{marginBottom:15}}>
                                    <select  className="select-cuerpo select-linea" value={estado} onChange={manejaEstado}>
                                        <option value="">Seleccione estado</option>
                                        <option value="En revisión">En revisión</option>
                                        <option value="Aceptada">Aceptada</option>
                                        <option value="Rechazada">Rechazado</option>
                                    </select>
                                </Col>
                                 <Col lg={3} md={6} sm={12} style={{marginBottom:15}}>
                                    {
                                        estado==='Aceptada' && 
 
                                        <SelectCiclos maneja={manejaCiclo} ciclo={ciclo} clase="select-linea"/>
 
                                    } 
                                </Col>
 
 
                            </Row>
                        </CardBody>
 
                        {
                            mostrarGuardar && 
                            <CardFooter className="text-right">
                                <Button color="success" size="sm" onClick={()=>{confirmar()}}>
                                    Guardar
                                </Button>
                            </CardFooter>
                        }
 

                    </Card>
 
                </ModalBody>
 
            </Modal>
 
        )
                    }
};
 
export default ModalPostulacion;